/*
 * File: \lib\event.js
 * File Created: 2022-06-23 18:38:19
 * Author: Ocean Li ���
 * -----
 * Last Modified: 2022-06-27 17:30:47
 * Modified By: Ocean Li ���
 */
import log from "./log.js";
import config from "../config.js";

const { error: Err } = log;

const getEventObj = (eventName) => {
  let event = null;
  if (!window[config.eventObjName].has(eventName)) {
    event = new Event(eventName);
    window[config.eventObjName].set(eventName, {
      event: event,
      funcs: [],
    });
  }
  return window[config.eventObjName].get(eventName);
};

const setEventFns = (eventName, fn) => {
  let eventObj = getEventObj(eventName);
  if (eventObj) {
    eventObj.funcs.push(fn);
  }
};

const getEventFns = (eventName) => {
  let eventObj = getEventObj(eventName);
  if (eventObj) {
    return eventObj.funcs;
  } else {
    return [];
  }
};

export default class mxEvent {
  constructor() {
    if (
      !window[config.eventObjName] ||
      !window.hasOwnProperty(config.eventObjName) ||
      window[config.eventObjName] == null
    ) {
      window[config.eventObjName] = new Map();
    }
  }

  // 触发事件
  triger(eventName, data) {
    let event = getEventObj(eventName).event || null;
    if (event) {
      event["mx_eventData"] = data;
      window.dispatchEvent(event);
    } else {
      Err(9000);
    }
  }

  on(eventName, func) {
    let execFn = function(e) {
        execFn.fn = func;
        execFn.fn(e["mx_eventData"]);
    }
    setEventFns(eventName, execFn);
    window.addEventListener(eventName, execFn, false);
  }

  off(eventName, func) {
    let cb;
    let cbs = getEventFns(eventName);
    let i = cbs.length;
    let fn = null;
    while (i--) {
      cb = cbs[i];
      if (cb.fn === func) {
        fn = cbs.splice(i, 1);
        break;
      }
    }
    window.removeEventListener(eventName, fn[0], false);
  }
}
